<template>
  <div class="page-login">
    <header>
      <div class="content">
        <a href="/"><img src="/images/logo.svg" class="header-logo" /></a>
        <a href="/register" class="header-button-si">Sign Up</a>
      </div>
    </header>
    <section class="login">
      <div class="content">
        <div class="login-form">
          <h1>Sign In</h1>
          <!--    <p>As a new user, you must activate your account before signing in for the first time. To activate your account, please do the following:<br />
           Go to your email account and look for an email from <a href="mailto:noreply@proptecham.ai">noreply@proptecham.ai</a> with instructions on how to activate your account. <strong><u>If you can’t find this email in your inbox, please check your spam folder.</u></strong><br />
           Follow the steps on the email and activate your account.<br />
           Once you have done this, you should be able to log in and access your account.</p>
    <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</p> -->
          <form class="form-horizontal form-material" id="loginform" @submit.prevent="submit" @keydown="loginForm.errors.clear($event.target.name)">
            <label for="email">Email</label>
            <input type="text" name="email" id="email" v-model="loginForm.email" />
            <show-error :form-name="loginForm" prop-name="email"></show-error>

            <label for="password">Password</label>
            <input type="password" name="password" v-model="loginForm.password" />
            <show-error :form-name="loginForm" prop-name="password"></show-error>

            <p v-if="getConfig('reset_password')">{{trans('auth.forgot_your_password?')}} <router-link to="/password" class="text-info m-l-5"><b>{{trans('auth.reset_here!')}}</b></router-link></p>

            <!-- <div class="social">
              <a v-for="provider in social_login_providers" v-if="getConfig(provider+'_login')" :href="`/auth/social/${provider}`" :class="['btn','btn-'+provider,'m-r-5','no-hover']" v-tooltip="trans('auth.login_with',{type:provider})"> <i :class="['fab','fa-'+provider]"></i></a>
            </div> -->

           <h3>or sign in with</h3>
            <ul class="login-social">
              <li class="icon-linkedin" @click="goSocial('linkedin')"><input type="radio" name="social" id="social-linkedin" /><label for="social-linkedin">LinkedIn</label></li>
              <li class="icon-google" @click="goSocial('google')"><input type="radio" name="social" id="social-google" /><label for="social-google">Google</label></li>
              <li class="icon-microsoft" @click="goSocial('microsoft')"><input type="radio" name="social" id="social-microsoft" /><label for="social-microsoft">Microsoft</label></li>
            </ul>
            <button class="button" style="margin-top:30px;">CONTINUE</button>
          </form>
        </div>
        <div class="login-hiw">
          <h2>Here’s how it works</h2>
          <ul>
            <li><i>1</i><h3>Complete our first questionnaire</h3><p>Tell us more about your investor preferences and your investment offering</p></li>
            <li><i>2</i><h3>Get some free, suitable investor insights</h3><p>based on the information submitted</p></li>
            <li><i>3</i><h3>Book a video call with one of our experts</h3><p>Our team will review your offering and give you a quote</p></li>
          </ul>
          <div class="clear"></div>
        </div>
        <div class="clear"></div>
      </div>
    </section>
  </div>
</template>

<script>
import guestFooter from '../../layouts/guest-footer.vue'

export default {
  data() {
    return {
      loginForm: new Form({
        email: '',
        password: ''
      }),
      social_login_providers: []
    }
  },
  components: {
    guestFooter
  },
  mounted(){

    $("body").addClass("page-login");

    axios.get('/sanctum/csrf-cookie').then(response => {});

    if(helper.getConfig('social_login'))
      axios.get('/api/configuration/variable?type=social_login')
          .then(response => response.data)
          .then(response => {
            this.social_login_providers = response.social_login_providers;
          })
          .catch(error => {
            helper.showDataErrorMsg(error);
          });
  },
  methods: {
    submit(){
      this.loginForm.post('/api/auth/login')
          .then(response =>  {
            this.$store.dispatch('setAuthStatus');
            this.$store.dispatch('setLastActivity');
            toastr.success(response.message);

            if(helper.getConfig('two_factor_security') && response.two_factor_code){
              this.$store.dispatch('setTwoFactorCode',response.two_factor_code);
              this.$router.push('/auth/security');
            }
            else {
              if(this.hasRole('admin') || response.user.roles[0].id==1) {
                var redirect_path = response.reload ? '/account/users/general-partners?reload=1' : '/account/users/general-partners';
              }else{
                if(response.user.profile.is_premium == 1) {
                  var redirect_path = response.reload ? '/account/dashboard?reload=1' : '/account/dashboard';
                }else if(response.user.profile.investor_types != ''){
                  var redirect_path = response.reload ? '/account/investor-analysis?reload=1' : '/account/investor-analysis';
                }else{
                  var redirect_path = response.reload ? '/account/dashboard?reload=1' : '/account/dashboard';
                }
              }

              this.$store.dispatch('resetTwoFactorCode');
              this.$router.push(redirect_path);
            }
          }).catch(error => {
        helper.showErrorMsg(error);
      });
    },
   /* loginAsAdmin(){
      this.loginForm.email = 'john.doe@example.com';
      this.loginForm.password = 'password';
      this.submit();
    },
    loginAsUser(){
      this.loginForm.email = 'marry.jen@example.com';
      this.loginForm.password = 'password';
      this.submit();
    }, */
    goSocial(provider){
      location.href='/auth/social/'+provider;
    },
    getConfig(config){
      return helper.getConfig(config);
    },
    hasRole(role){
      return helper.hasRole(role);
    },
  }
}
</script>